import React, { useImperativeHandle, useRef, useState } from 'react';
import { Badge, Button, Drawer, IconButton, MenuItem } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import MenuComponent from 'components/MenuComponent';
import IntlMessages from 'util/IntlMessages';
import { MenuContext, useMenuContext } from 'components/MenuComponent/context';
import {
  NewWorkRequest,
  NewWorkRequestFormContainer,
} from 'modules/cbre-flow-lab-new-work-request';
import { useHistory, useLocation } from 'react-router-dom';
import InstrumentRequestForm from 'app/MultiARCForm';
import { useDispatch, useSelector } from 'react-redux';
import AccessControl, { ACCESSLEVEL } from 'modules/cbre-flow-Common/components/AccessControl';
import { openViewDialog } from '../ducks/actions';
import { DIALOG_SUBTYPES, DIALOG_TYPES } from '../ducks/constants';


type Props = {
  buttonProps?: any;
  data?: any;
  anchorOrigin?: {
    vertical: 'top' | 'bottom' | 'center' | number;
    horizontal: 'left' | 'right' | 'center' | number;
  };
};

const ViewManagementAddFiltersButton = React.forwardRef<any, Props>(
  (props, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();


    const toggleDrawer = () => {
      setIsOpen(!isOpen);
    };

    const handleDrawer = (mode: any) => {
      toggleDrawer();
    };

    useImperativeHandle(
      ref,
      () => ({
        handleDrawer,
        onClose,
      }),
      [],
    );

    const onClose = () => {
      setIsOpen(false);
    };


    return (
      <>
      {/*  <AccessControl
       allowedPermissions={[ACCESSLEVEL.EDIT]}
      > */}
        <div>
          <MenuComponent
            // startIcon={<AddIcon />}
            label={
              "Add filters"}
            {...(props.buttonProps || {})}
            MenuProps={{
              PaperProps: {
                sx: {
                  width: 'auto !important',
                  // minWidth: '200px',
                },
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
              },
              anchorOrigin: {
                vertical: props.anchorOrigin?.vertical || 'bottom',
                horizontal: props.anchorOrigin?.horizontal || 'right',
              }
            }}

          >
            <MenuContext.Consumer>
              {({ handleClose }) => (
                <>

                  <MenuItem
                    onClick={() => {
                      handleClose();
                      dispatch(openViewDialog(DIALOG_TYPES.EDIT, DIALOG_SUBTYPES.EDIT_SITE_LIST as any));
                    }}
                    disableRipple
                  >

                    Site
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleClose();
                      dispatch(openViewDialog(DIALOG_TYPES.EDIT, DIALOG_SUBTYPES.EDIT_COST_CENTER_LIST as any));
                    }}
                    disableRipple
                  >

                    Cost Center
                  </MenuItem>



                </>
              )}
            </MenuContext.Consumer>
          </MenuComponent>

        </div>
      {/* </AccessControl> */}
      </>
    );
  },
);

ViewManagementAddFiltersButton.displayName =
  'ViewManagementAddFiltersButton';
export { ViewManagementAddFiltersButton };
